import React, { useState, useEffect } from "react";
import "./index.css";
import { Image, Specimen } from "../../../../types";
import { Button, Grid, Typography } from "@mui/material";

interface Props {
  selectedSpecimen: Specimen | null;
  fetchImagesById: () => void;
  imgs: Image[];
  selectImageToView: (img: Image) => void;
}

const HorizontalGallery: React.FC<Props> = ({
  fetchImagesById,
  imgs = [],
  selectImageToView,
}) => {
  const [selectedImage, setSelectedImage] = useState("");
  
  useEffect(() => {
    // set selected image to the first one if necessary
    if (imgs.length > 0 && !selectedImage) {
      setSelectedImage(imgs?.[0]?.id || "");
    }
  }, [imgs, selectedImage, setSelectedImage])

  const handleSelectImage = (image: Image) => {
    setSelectedImage(image.id);
    selectImageToView(image);
  }

  return (
    <div className="horizontal-image-gallery">
      {imgs.length === 0 ? (
        <Button onClick={() => fetchImagesById()} className="btn-fetch-images">
          Fetch More Specimen Images
        </Button>
      ) : (
        <>
          <Typography className="title-specimen-images">
            Specimen Images
          </Typography>
          <Grid
            container
            direction="row"
            spacing={2}
            sx={{ overflowX: "auto", flexWrap: "nowrap", padding: 2 }}
            className="horizontal-image-container"
          >
            {imgs &&
              imgs.map((img) => {
                return (
                  <img
                    src={img.img}
                    alt={img.id}
                    width="120"
                    height="120"
                    style={{
                      border:
                        img.id === selectedImage
                          ? "4px #428BCA solid"
                          : "4px #ffffff solid",
                    }}
                    onClick={() => handleSelectImage(img)}
                  />
                );
              })}
          </Grid>
        </>
      )}
    </div>
  );
};

export default HorizontalGallery;
